/**
 * SunoVideoViewerSheet — показ готового music-video. Смонтирован на App-
 * уровне, открывается автоматически по pendingViewer из SunoVideoJobsContext.
 */
import Sheet from '../../../components/Sheet'
import MediaPlayer from '../../../components/MediaPlayer/MediaPlayer'
import { Icon } from '../../../../public/icons/Icon.tsx'
import { showToast } from '../../../components/Toast'
import { useSunoVideoJobs } from '../../../context/SunoVideoJobsContext'

export default function SunoVideoViewerSheet() {
	const { pendingViewer, dismissViewer } = useSunoVideoJobs()
	if (!pendingViewer) return null

	const { videoUrl, title, imageUrl } = pendingViewer

	const downloadVideo = async () => {
		try {
			const response = await fetch(videoUrl)
			if (!response.ok) throw new Error(`HTTP ${response.status}`)
			const blob = await response.blob()
			const objectUrl = URL.createObjectURL(blob)
			const a = document.createElement('a')
			a.href = objectUrl
			const safe = (title?.trim() || 'suno-video')
				.replace(/[\\/:"*?<>|]/g, '_')
				.slice(0, 100)
			a.download = `${safe}.mp4`
			document.body.appendChild(a)
			a.click()
			a.remove()
			setTimeout(() => URL.revokeObjectURL(objectUrl), 10_000)
		} catch {
			showToast('Не удалось скачать видео', 'error')
		}
	}

	return (
		<Sheet
			open={!!pendingViewer}
			onClose={dismissViewer}
			variant="center"
			title="Видеоклип"
			className="suno-video-viewer"
		>
			<div className="suno-video-viewer__body">
				{title?.trim() && (
					<div className="suno-video-viewer__track">{title.trim()}</div>
				)}

				<MediaPlayer
					variant="video"
					src={videoUrl}
					autoPlay
					poster={imageUrl || undefined}
					className="suno-video-viewer__player-wrap"
					videoClassName="suno-video-viewer__player"
					onDownload={() => { void downloadVideo() }}
				/>

				<div className="suno-video-viewer__actions">
					<button
						type="button"
						className="suno-video-viewer__download"
						onClick={downloadVideo}
						title="Скачать видеоклип .mp4"
					>
						<Icon id="gen-download" size={14} />
						Скачать .mp4
					</button>
				</div>

				<p className="suno-video-viewer__hint">
					Музыкальный видеоклип сгенерирован Suno на основе твоего трека.
					Длительность совпадает с длительностью аудио.
				</p>
			</div>
		</Sheet>
	)
}
